import { Button, HStack, Image, Spacer, Text, VStack } from '@chakra-ui/react';
import { AccountContext } from 'components/AccountContext';
import { getAppTheme, userIsSubscriber } from 'components/Utils/theme';
import React, { useContext, useState } from 'react';
import TelemedDeslogado from '../../../../../../src/images/Deslogado/telemedDeslogado.svg';
import Contact from '../../../../../images/ClinicoIcon.svg';
import { useLocation, useNavigate } from 'react-router-dom';
import Psicologo from '../../../../../images/modalPsicologo.svg';
import socketIOClient from 'socket.io-client';

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

function PreAtendimento() {
  const { user, socket } = useContext(AccountContext);
  const theme = getAppTheme(userIsSubscriber(user));
  const usuarioAssinante = userIsSubscriber(user);
  const navigate = useNavigate();
  const state = useLocation();
  const [error, setError] = useState(false);
  const atendimentoId = state?.state?.atendimentoId ?? null;
  return !error ? (
    <>
      <VStack w="100%" minH="100vh" bg={theme.background} justify="center" align="center">
        <VStack bg="white" p={6} borderRadius={'0.8em'} m={'5%'}>
          <Image top={{ lg: '5.5em', sm: '5em' }} src={!usuarioAssinante ? TelemedDeslogado : Contact} height={'4.5em'} />
          <Text fontSize={'2em'} color={'#5AB2AE'} fontWeight="bold">
            Prontinho!
          </Text>
          <Text color={'#5AB2AE'} textAlign={'justify'} fontSize={'1.3em'} letterSpacing={'-0.08em'}>
            O profissional de saúde está esperando por você!
          </Text>
          <Text color={'#5AB2AE'} textAlign={'justify'} fontSize={'1.3em'} letterSpacing={'-0.08em'}>
            Para garantir a qualidade do atendimento, mova-se para um local bem iluminado e confira sua conexão com a internet.
          </Text>
          <Spacer mb={'1em'} />
          <Button
            fontSize={'1.2em'}
            borderRadius={'0.8em'}
            w={'100%'}
            fontWeight="bold"
            color={theme.fontcolor}
            bg={theme.background}
            _focus={false}
            onClick={() => {
              /*
              socket.emit('enterTelemedicina', { salaId: atendimentoId, userId: user.id_cliente_deovita });
              socket.on('teleError', (msg) => {
                setError(true);
                return;
              });

              socket.on('teleJoined', (msg) => { */
              const nomePartes = user?.name.split(' ');
              const primeiroNome = nomePartes[0];
              const sobrenome = nomePartes.length > 1 ? nomePartes[1] : '';
              navigate('/video-chamada', {
                state: {
                  channelName: `telemedicina_${atendimentoId}`,
                  userId: `${primeiroNome} ${sobrenome}`,
                  jwt: '123',
                  agenda_exames_id: atendimentoId,
                },
              });
              // });
            }}
          >
            Ir para o atendimento
          </Button>
        </VStack>
      </VStack>
    </>
  ) : (
    <>
      <VStack w="100%" minH="100vh" bg={theme.background} justify="center" align="center">
        <VStack bg="white" p={8} borderRadius={'1em'} boxShadow="lg" spacing={6} maxW="400px" align="center">
          <Image src={Psicologo} boxSize="5em" mb={2} />
          <Text color={'#5AB2AE'} fontWeight="bold" fontSize={'1.5em'} textAlign="center" mb={2}>
            Sala ocupada
          </Text>
          <Text color={'gray.700'} textAlign={'justify'} fontSize={'1.1em'} mb={4}>
            Opa! Já existe um atendimento em andamento nesta sala. Por favor, aguarde até que ele seja concluído. Se não reconhece, entre em contato
            com o suporte.
          </Text>
          <HStack w={'100%'} spacing={4} justify="center">
            <Button
              colorScheme="gray"
              variant="outline"
              flex={1.2}
              borderRadius="0.7em"
              padding={'1.5em'}
              onClick={() => {
                /*window?.ReactNativeWebView?.postMessage(
                    JSON.stringify({
                      service: true,
                      openInBrowser: true,
                      url: 'https://wa.me/5508002802133',
                    })
                  );*/
                window?.open('https://wa.me/5508002802133', '_blank');
              }}
            >
              Falar com o <br /> suporte
            </Button>
            <Button colorScheme="orange" variant="solid" flex={1.2} borderRadius="0.7em" padding={'1.5em'} onClick={() => navigate('/dashboard')}>
              Ir para o menu
            </Button>
          </HStack>
        </VStack>
      </VStack>
    </>
  );
}

export default PreAtendimento;
